import React from "react";
import { useField } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function SubmitButton({ type, isSubmitting, text, ...props }) {
    const [field, meta] = useField(props);

    return (
        <button
            {...field}
            {...props}
            type="submit"
            disabled={isSubmitting === true}
            className={classNames(
                "relative justify-center inline-flex text-white uppercase items-center px-4 py-2 rounded-lg border text-sm focus:z-10 focus:outline-none border-primary bg-primary hover:bg-primary_hover focus:ring-primary focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-ease-out hover:-translate-y-0.5",
                props.className
            )}
        >
            {isSubmitting === true ? (
                <FontAwesomeIcon className="animate-spin" icon={faSpinnerThird} />
            ) : (
                <>
                    {props.icon && (
                        <span className="w-4">
                            <FontAwesomeIcon className="w-4 h-4" icon={props.icon} />
                        </span>
                    )}
                    <span className="w-full">{text}</span>
                </>
            )}
        </button>
    );
}
